const env = process.env.NODE_ENV;
const baseUrl = () => {
  const development = ""; // 开发环境
  const test = ""; // 测试环境
  const production = ""; // 正式环境
  return {
    development,
    test,
    production
  } [env];
};

const fileUrl = () => {
  return {
    development: "",
    test: "",
    production: ""
  } [env];
};
const audioUrl = fileUrl() + "/file/";
const uploadImg = fileUrl() + "/upload";
const showImg = fileUrl() + "/image/";
const showFile = fileUrl() + "/file/";
export {
  audioUrl,
  uploadImg,
  showImg,
  showFile,
  baseUrl
};
